<template>

<div class="page-content model-content mb-5">

    <div v-if='isReady' class="container-fluid">
        <!-- Model Info -->
        <div class="row d-flex justify-content-center single-model-info">
            <div class="col-lg-4 col-md-5 text-center text-md-left pl-md-0">
                <span class="border-grid img-link d-inline-block profile-image">        
                    <img :alt="model.name" 
                         :src="model.avatar" class="img-fluid">
                </span>
            </div>
            <div class="col-lg-8 col-md-7">
                <div class="page-header p-0">

                    <!-- Title & Social Links -->
                    <div class="d-flex align-items-lg-center justify-content-between d-flex flex-column flex-lg-row mb-0">

                        <div class="d-flex justify-content-start align-items-center flex-column flex-md-row">
                            <h2 class="page-title text-uppercase mb-0 text-center text-md-left">
                                {{ model.name }}
                            </h2>
                        </div>
                        
                        <!-- Social Icons -->
                        <ul class="list-inline d-flex align-items-center justify-content-center justify-content-md-start mb-0 mt-2 mt-lg-0">

                            <li v-if='model.only_fans' class="list-inline-item">
                                <a :href="model.only_fans" target="_blank" class="btn btn-outline-primary" title="OnlyFans">
                                    <span class="icon icon-onlyfans"></span>
                                    Chat with me
                                </a>
                            </li>

                            <li v-if='model.instagram' class="list-inline-item model-social ml-3">
                                <a :href="model.instagram" target="_blank" title="Instagram">
                                    <span class="icon icon-instagram"></span>
                                </a>
                            </li>

                            <li v-if='model.twitter' class="list-inline-item model-social ml-3">
                                <a :href="model.twitter" target="_blank" title="Twitter">
                                    <span class="icon icon-twitter"></span>
                                </a>
                            </li>

                            <li v-if='model.telegram' class="list-inline-item model-social ml-3">
                                <a :href="model.telegram" target="_blank" title="Telegram">
                                    <span class="icon icon-telegram"></span>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>

                <!-- Models Stats -->
                <div class="row">
                    <div class="col-12 d-flex align-items-lg-center align-items-md-start align-items-center flex-column flex-lg-row">
                        <div class="model-stats mt-2 mb-2">
                            <span class="views mr-0">
                                <span class="icon icon-eye"></span>
                                {{ model.previews }}
                            </span>                         
                        </div>
                        <span v-if='model.trending == 1' class="trending ml-lg-4 ml-md-2 mt-1">
                            Trending Model
                        </span>
                    </div>
                </div>

                <!-- Basic Info -->
                <div class="row mt-4 mt-md-3">
    
                    <div class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">
                        <span class="icon icon-flag" title="Country"></span>
                        {{ ucFirst(model.country) }}
                    </div>

                    <div class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">
                        <span class="icon icon-wind" title="Hair Color"></span>
                        {{ ucFirst(model.hair) }}
                    </div>

                    <div v-if='model.silicone == 1' 
                         class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">                     
                        <span class="icon icon-silicone" title="Silicone"></span>
                        Silicone                        
                    </div>

                    <div v-if='model.cosplay == 1' 
                         class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1"> 
                        <span class="icon icon-bunny" title="Cosplay"></span>
                        Cosplay
                    </div>

                    <div v-if='model.tattoo == 1' class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">
                        <span class="icon icon-paintbrush" title="Tattoo"></span>
                        Tattoo
                    </div>

                    <div v-if='model.teen == 1' class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">
                        <span class="icon icon-ice-cream" title="Teen"></span>
                        Teen
                    </div>

                    <div class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">
                        <span class="icon icon-users" title="Ethnicity"></span>
                        Ethnicity: {{ model.ethnicity }}
                    </div>

                    <div class="col-xl-4 col-md-6 col-sm-4 col-6 mb-1">
                        <span class="icon icon-hip" title="Body type"></span>
                        Body type: {{ model.body_type }}
                    </div>
                
                </div>

                <!-- Text Info -->
                <div class="row mt-3">
                    <div class="col-12">
                        <div id="model-desc">
                            <div class="cont" v-html='model.desc'></div>
                            <a id="model-toggle" class="btn btn-outline-primary mt-3">
                                <span id="show-more" class="d-flex align-items-center">
                                    <span class="icon icon-plus-circle"></span>
                                    Show more
                                </span>
                                <span id="show-less" class="d-none align-items-center">
                                    <span class="icon icon-minus-circle"></span>
                                    Show less
                                </span>
                            </a>
                            <a :href="url('onlyfans-models/' + model.slug )" class="btn btn-outline-primary" style="position: absolute; bottom: 0; right: 0;">
                                <span class="d-flex align-items-center">
                                    <span class="icon icon-image"></span>
                                    See the photos
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
       
    </div>

</div>

</template>

<script>
    export default {

        mounted() {


        },

        created() {

            if( typeof this.slug == 'string' && this.slug ) {
                this.getData();
            }

        },

        props : ['slug'],

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

            getData() {
                this.ajax.call('mdl:gspd', { m : this.slug }, (r) => {
                    
                    if ( r.status == 'success' ) {

                        this.model  = r.data.model;
                        this.videos = r.data.v;
                        this.images = r.data.i;

                        this.isReady = true;
                        this.$nextTick(this.initToggleTxt);
                    }

                })
            },

            initToggleTxt() {

                function showMoreBtn(x) {
                    $(x).find('#show-more').toggleClass('d-none');
                    $(x).find('#show-more').toggleClass('d-flex');
                    $(x).find('#show-less').toggleClass('d-none');
                    $(x).find('#show-less').toggleClass('d-flex');
                }

                $('#model-toggle').on('click', function(){
                    showMoreBtn(this);
                    $("#model-desc").toggleClass("desc-collapsed", 1000);
                });

                var count = $("#model-desc").text().length;
                if(count > 400) {
                    $("#model-toggle").removeClass("d-none");
                    $("#model-desc").addClass("desc-collapsed");
                    $("#model-desc").addClass("has-button");
                }

            }
        }

    }
</script>
